import { Grid } from '@mui/material';
import { getDashboardAllInstMeetingCountsApi, getDashboardMeetingCountInfoApi, getDashboardMeetingCountInfoByUnitsApi, getDashboardUserCountInfoApi, getParticipantDashboardInfoFromUserIdApi } from 'api/meeting';
import { isRoleCheckList } from 'app/utils/appHelpers';
import config from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import DashboardKurulOnlyDesign from 'app/components/Card/dashboardDesign/DashboardKurulOnlyDesign';
import DashboardSuperUserDesign from 'app/components/Card/dashboardDesign/DashboardSuperUserDesign';
import DashboardUyeOnlyDesign from 'app/components/Card/dashboardDesign/DashboardUyeOnlyDesign';
import DashboardYkAndKurulDesign from 'app/components/Card/dashboardDesign/DashboardYkAndKurulDesign';
import DashboardYkOnlyDesign from 'app/components/Card/dashboardDesign/DashboardYkOnlyDesign';
import DashboardYKUzmanDesign from 'app/components/Card/DashboardYKUzmanDesign';
import DashboardAnnouncementsCard from 'app/components/Card/DashboardAnnouncementsCard';
import LoadingPopUp from 'app/components/LoadingPopup';


function DashboardHomePage({ }) {
    //test cicd

    const { authUser } = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const [countList, setCountList] = useState({});
    const [countUserInfo, setCountUserInfo] = useState({});

    const [ykCountList, setYKCountList] = useState({});
    const [kurulCard, setKurulCard] = useState(false);
    const [ykCard, setYkCard] = useState(false);
    const [uyeCard, setUyeCard] = useState(false);
    const [participantList, setParticipantList] = useState([]);
    const [superUserCard, setSuperUserCard] = useState(false);
    const [allInstMeetingCounts375, setAllInstMeetingCounts375] = useState([]);
    const [ykUzmanCard, setYkUzmanCard] = useState(false);
    const [announcementsCard, setAnnouncementsCard] = useState(false);

    const userRoles = authUser && authUser.userRoles;


    useEffect(() => {
        const getAPI = async () => {

            setLoading(true);
            try {

                const filteredInsts = config.institutions.filter(item => item.inst !== "YK").map(item => item.inst);

                if (isRoleCheckList(userRoles, [375])) {
                    const resAllInst = await getDashboardAllInstMeetingCountsApi();
                    if (resAllInst !== undefined && resAllInst.data !== undefined) {
                        setAllInstMeetingCounts375(resAllInst.data);
                        setYkUzmanCard(true);
                    }
                }

                if (isRoleCheckList(userRoles, [1])) { // 370  tüm toplantilari görmeye yetkili
                    const res = await getDashboardUserCountInfoApi(authUser.id, "all")
                    if (res !== undefined && res.data !== undefined) {
                        setCountUserInfo(prevState => ({
                            ...res.data[0],
                        }));
                    }


                    // kurullar için
                    const resKurul = await getDashboardUserCountInfoApi(authUser.id, filteredInsts)
                    if (resKurul !== undefined && resKurul.data !== undefined) {
                        setCountList(prevState => ({
                            ...prevState,
                            userAdminMeetingCount: resKurul.data[0].userAdminMeetingCount,
                        }));
                    }

                    // yk için
                    const resyk = await getDashboardUserCountInfoApi(authUser.id, 'YK')

                    if (resyk !== undefined && resyk.data !== undefined) {
                        setYKCountList(prevState => ({
                            ...prevState,
                            userAdminMeetingCount: resyk.data[0].userAdminMeetingCount,
                        }));
                    }

                    setSuperUserCard(true);
                } else if (isRoleCheckList(userRoles, [373, 369])) {
                    const res = await getDashboardUserCountInfoApi(authUser.id, filteredInsts)
                    if (res !== undefined && res.data !== undefined) {
                        setCountUserInfo(prevState => ({
                            ...res.data[0],
                        }));

                        setCountList(prevState => ({
                            ...prevState,
                            userAdminMeetingCount: res.data[0].userAdminMeetingCount,
                        }));
                    }

                } else if (isRoleCheckList(userRoles, [370])) {


                    const res = await getDashboardUserCountInfoApi(authUser.id, "YK")

                    if (res !== undefined && res.data !== undefined) {
                        setCountUserInfo(prevState => ({
                            ...res.data[0],
                        }));
                        setYKCountList(prevState => ({
                            ...prevState,
                            userAdminMeetingCount: res.data[0].userAdminMeetingCount,
                        }));
                    }

                }
                // user count bolumu


                // kurul card icin
                if (isRoleCheckList(userRoles, [1])) { // 370  tüm toplantilari görmeye yetkili

                    const res2 = await getDashboardMeetingCountInfoApi(authUser.id, filteredInsts)

                    if (res2 !== undefined && res2.data !== undefined) {
                        setCountList(prevState => ({
                            ...res2.data[0],
                            userAdminMeetingCount: prevState.userAdminMeetingCount,
                        }));
                    }
                    const res3 = await getDashboardMeetingCountInfoApi(authUser.id, 'YK') // ???? ornek id 1210
                    if (res3 !== undefined && res3.data !== undefined) {
                        setYKCountList(prevState => ({
                            ...res3.data[0],
                            userAdminMeetingCount: prevState.userAdminMeetingCount,
                        }));
                    }


                } else {
                    if (isRoleCheckList(userRoles, [370])) { // 370  tüm toplantilari görmeye yetkili

                        const res3 = await getDashboardMeetingCountInfoApi(authUser.id, 'YK')

                        if (res3 !== undefined && res3.data !== undefined) {
                            setYKCountList(prevState => ({
                                ...res3.data[0],
                                userAdminMeetingCount: prevState.userAdminMeetingCount,
                            }));
                        }
                        setYkCard(true);

                    }
                    if (isRoleCheckList(userRoles, [372])) {

                        let unitMeeting = [];
                        let filteredUserRoles = userRoles.filter(item => item.id === 372);

                        filteredUserRoles.forEach(e => {
                            unitMeeting.push(e.customId);
                        });
                        const roleGroups = [370, 372];

                        const res2 = await getDashboardMeetingCountInfoByUnitsApi(authUser.id, roleGroups)

                        if (res2 !== undefined && res2.data !== undefined) {

                            setYKCountList(prevState => ({
                                ...res2.data[0],
                                userAdminMeetingCount: prevState.userAdminMeetingCount,
                            }));
                        }
                        setYkCard(true);

                    }

                    if (isRoleCheckList(userRoles, [373])) { // kurum yoneticisi

                        const userRole = authUser.userRoles.filter(x => x.id === 373);
                        const insts = userRole.map(x => x.inst)
                        const res2 = await getDashboardMeetingCountInfoApi(authUser.id, insts) // ???? ornek id 1210


                        if (res2 !== undefined && res2.data !== undefined) {
                            setCountList(prevState => ({
                                ...res2.data[0],
                                userAdminMeetingCount: prevState.userAdminMeetingCount,
                            }));
                        }
                        setKurulCard(true);

                    } if (isRoleCheckList(userRoles, [369])) { // toplanti yoneticisi

                        let unitMeeting = [];
                        let filteredUserRoles = userRoles.filter(item => item.id === 369);

                        filteredUserRoles.forEach(e => {
                            unitMeeting.push(e.customId);
                        });
                        const roleGroups = [373, 369];

                        const res2 = await getDashboardMeetingCountInfoByUnitsApi(authUser.id, roleGroups)
                        if (res2 !== undefined && res2.data !== undefined) {
                            setCountList(prevState => ({
                                ...res2.data[0],
                                userAdminMeetingCount: prevState.userAdminMeetingCount,
                            }));
                        }
                        setKurulCard(true);
                    }
                }

                // if (isRoleCheckList(userRoles, [100])) {
                //     setUyeCard(true);
                // }



                if (!isRoleCheckList(userRoles, [375])) {

                    if (isRoleCheckList(userRoles, [100])) {

                        setUyeCard(true);

                        const res = await getDashboardUserCountInfoApi(authUser.id, "all")

                        if (res !== undefined && res.data !== undefined) {
                            setCountUserInfo(prevState => ({
                                ...res.data[0],
                            }));
                        }
                    }
                    const res = await getDashboardUserCountInfoApi(authUser.id, "all")
                    if (res !== undefined && res.data !== undefined) {
                        setCountUserInfo(prevState => ({
                            ...res.data[0],
                        }));
                    }

                }

                const resPart = await getParticipantDashboardInfoFromUserIdApi(authUser.id)

                if (resPart !== undefined && resPart.data !== undefined) {
                    setParticipantList(resPart.data)
                }


                const hasOtherRoles = isRoleCheckList(userRoles, [373, 370, 369, 372]);
                const hasAnnouncementRoles = isRoleCheckList(userRoles, [416, 417]);
                if (!hasOtherRoles && hasAnnouncementRoles) {
                    setAnnouncementsCard(true);
                }




            } catch (error) {
                console.error('Hata:', error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();

    }, []);


    return (
        <>
            <LoadingPopUp open={loading} />
            {!loading &&
                <Grid container spacing={1}>
                    {ykUzmanCard === true && (
                        <Grid item xs={12}>
                            <DashboardYKUzmanDesign instCounts={allInstMeetingCounts375} participantList={participantList} />
                        </Grid>
                    )}

                    {/* SuperUser Card */}
                    {superUserCard === true && (
                        <DashboardSuperUserDesign
                            userRoles={userRoles}
                            countUserInfo={countUserInfo}
                            countList={countList}
                            ykCountList={ykCountList}
                        />
                    )}

                    {/* YK ve Kurul Card */}
                    {(ykCard === true && kurulCard === true && uyeCard === false) && (
                        <DashboardYkAndKurulDesign
                            countList={countList}
                            countUserInfo={countUserInfo}
                            ykCountList={ykCountList}
                        />
                    )}

                    {/* Sadece Kurul Card */}
                    {(ykCard === false && kurulCard === true && uyeCard === false) && (
                        <DashboardKurulOnlyDesign
                            countList={countList}
                            countUserInfo={countUserInfo}
                            participantList={participantList}
                        />
                    )}

                    {/* Sadece YK Card */}
                    {(ykCard === true && kurulCard === false && uyeCard === false) && (
                        <DashboardYkOnlyDesign
                            countUserInfo={countUserInfo}
                            ykCountList={ykCountList}
                            participantList={participantList}
                        />
                    )}

                    {/* Sadece Üye Card */}
                    {superUserCard === false && uyeCard === true && (
                        <DashboardUyeOnlyDesign
                            countUserInfo={countUserInfo}
                        />
                    )}

                    {/* Duyurular Card */}
                    {announcementsCard === true && (
                        <Grid item xs={6}>
                            <DashboardAnnouncementsCard />
                        </Grid>
                    )}

                </Grid>
            }
        </>
    );
};

export default DashboardHomePage